export const ADD_ELEMENT = 'ADD_ELEMENT';
export const CHANGE_ELEMENT = 'CHANGE_ELEMENT';
export const DELETE_ELEMENT = 'DELETE_ELEMENT';
export const DELETE_ALL = 'DELETE_ALL';
export const CHANGE_CONTAINER = 'CHANGE_CONTAINER';
export const SELECT_ELEMENT = 'SELECT_ELEMENT';
export const CHANGE_ORDER = 'CHANGE_ORDER';
export const CHANGE_NAME = 'CHANGE_NAME';

export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';
export const LOAD = 'LOAD';
export const SET_LOADING = 'SET_LOADING';
export const DONE = 'DONE';